export default __webpack_public_path__ + "static/media/es-ga.23a30d01.svg";